import { render, staticRenderFns } from "./HeaderNaviComponent.vue?vue&type=template&id=47e5b12c&scoped=true&lang=pug&"
import script from "./HeaderNaviComponent.vue?vue&type=script&lang=js&"
export * from "./HeaderNaviComponent.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNaviComponent.vue?vue&type=style&index=0&id=47e5b12c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e5b12c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47e5b12c')) {
      api.createRecord('47e5b12c', component.options)
    } else {
      api.reload('47e5b12c', component.options)
    }
    module.hot.accept("./HeaderNaviComponent.vue?vue&type=template&id=47e5b12c&scoped=true&lang=pug&", function () {
      api.rerender('47e5b12c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HeaderNaviComponent.vue"
export default component.exports